import { Box } from "@mui/material";
import { DotLegalCheckbox, DotLegalDialog, DotLegalHeader, DotLegalMultiSelect, DotLegalSelect, DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import { useConvertObservationDialogDataMapping } from "./ConvertObservationDialog.hooks";
import { RiskObservationViewModel } from "../RiskObservations.types";

export interface IConvertObservationDialog {
    observation: RiskObservationViewModel;
    onCloseDialog: () => void;
    onConverted: () => void;
}

function ConvertObservationDialog(props: IConvertObservationDialog) {
    const { translateString } = useTranslation();
    const {
        form,
        validation,
        inProgress,
        setName,
        setDescription,
        setCategory,
        setRiskAreas,
        chosenRiskAreas,
        setEntityTypes,
        chosenEntityTypes,
        setNotifyResponsibles,
        categoryOptions,
        riskAreaOptions,
        riskAreasLoading,
        entityTypeOptions,
        validateAndConvert,
    } = useConvertObservationDialogDataMapping(props);

    return (
        <DotLegalDialog
            inProgress={inProgress}
            size="sm"
            buttonOkText={translateString("convert")}
            header={`${translateString("convertToRiskScenario")}: ${props.observation.name}`}
            onOkClick={validateAndConvert}
            onDialogClose={props.onCloseDialog}
            open
            disableBackdropOnCloseIfValueChange={form}
        >
            <Box sx={{ marginRight: 3 }}>
                <DotLegalHeader marginBottom={3} center fontWeight={400} headerStyle="small">
                    {translateString("convertObservationExplanation")}
                </DotLegalHeader>

                <DotLegalTextField
                    debounce={false}
                    size="small"
                    label={translateString("riskScenario")}
                    value={form.name}
                    onChange={setName}
                    errorText={validation.getErrorsForDisplay("name")}
                    multiline
                    rows={1}
                />
                <DotLegalTextField
                    debounce={false}
                    size="small"
                    multiline
                    rows={4}
                    label={translateString("description")}
                    value={form.description ?? ""}
                    onChange={setDescription}
                />
                <DotLegalSelect
                    label={translateString("category")}
                    options={categoryOptions}
                    selectedItem={form.category}
                    onChange={setCategory}
                    errorText={validation.getErrorsForDisplay("category")}
                    noOptionsLabel={translateString("noOptions")}
                />
                <DotLegalMultiSelect
                    label={translateString("riskAreas")}
                    options={riskAreaOptions}
                    chosenOptions={chosenRiskAreas}
                    onChange={setRiskAreas}
                    isLoading={riskAreasLoading}
                    noOptionsLabel={translateString("noOptions")}
                    errorText={validation.getErrorsForDisplay("riskAreas")}
                />
                <DotLegalMultiSelect
                    label={translateString("types")}
                    options={entityTypeOptions}
                    chosenOptions={chosenEntityTypes}
                    onChange={setEntityTypes}
                    noOptionsLabel={translateString("noOptions")}
                    errorText={validation.getErrorsForDisplay("entityTypes")}
                />

                <DotLegalCheckbox
                    checked={form.notifyResponsibles}
                    onChange={setNotifyResponsibles}
                    label={translateString("notifyOperationalResponsibles")}
                    tooltip={translateString("notifyOperationalResponsiblesHelper")}
                />
            </Box>
        </DotLegalDialog>
    );
}

export default ConvertObservationDialog;
